export default __webpack_public_path__ + "static/media/mobiledevelopment.c1c196a7.svg";